import React from 'react';

function SimpleTest() {
  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <h1 style={{ color: 'black' }}>Simple Test Page</h1>
    </div>
  );
}

export default SimpleTest; 